import LogService from "../../CommonSdk/LogService";

import * as PaymentsService from "../../RainbowSdk/PaymentsService";
import * as PaymentsActionTypes from "./PaymentsActionTypes";
import * as ErrorUtils from "../../Utils/ErrorUtils";

const LOG_TAG = "ACTIONS:PAYMENTS";
const SubscriptionPollingWaitMaxTrial = "10";

export const getPaymentMethods = (userId) => dispatch => {
    LogService.trace(LOG_TAG, "getPaymentMethods", "Get list of payment methods");

    dispatch({
        type: PaymentsActionTypes.GET_PAYMENT_METHODS_PROGRESS
    });

    return PaymentsService.getListOfPaymentsMethod(userId)
        .then(json => {
            LogService.trace(LOG_TAG, "getPaymentMethods", "successfully received", json.total);

            dispatch({
                type: PaymentsActionTypes.GET_PAYMENT_METHODS_RECEIVED,
                payload: {
                    payments: json.data
                }
            });
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "getPaymentMethods", "error", errorPayload);
            dispatch({
                type: PaymentsActionTypes.GET_PAYMENT_METHODS_ERROR
            });
            return Promise.reject(errorPayload);
        });
};

export const setAsDefault = (userId, paymentMethodId) => dispatch => {
    LogService.trace(LOG_TAG, "setAsDefault", "Set as default payment method");

    return PaymentsService.setAsDefault(userId, paymentMethodId)
        .then(json => {
            LogService.trace(LOG_TAG, "setAsDefault", "successfully received", json);

            dispatch(getPaymentMethods(userId));
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "setAsDefault", "error", errorPayload);
            return Promise.reject(errorPayload);
        });
};

export const deletePaymentMethod = (userId, paymentMethodId) => dispatch => {
    LogService.trace(LOG_TAG, "deletePaymentMethod", "Delete payment methods");

    return PaymentsService.deletePaymentMethod(userId, paymentMethodId)
        .then(() => {
            LogService.trace(LOG_TAG, "deletePaymentMethod", "successfully done", paymentMethodId);

            dispatch(getPaymentMethods(userId));
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "deletePaymentMethod", "error", errorPayload);
            return Promise.reject(errorPayload);
        });
};

export const clearPaymentMethods = () => dispatch => {
    LogService.trace(LOG_TAG, "clearPaymentMethods");
    dispatch({
        type: PaymentsActionTypes.CLEAR_PAYMENT_METHODS
    });
};

export const getRSASignatureForMethod = (userId, typeOfSignature) => dispatch => {
    LogService.trace(LOG_TAG, "getRSASignatureForMethod", "Get RSA signature for payment method CC");

    return PaymentsService.getSignatureForPaymentMethod(userId, typeOfSignature)
        .then((json) => {
            LogService.trace(LOG_TAG, "getRSASignatureForMethod", "successfully received");
            return Promise.resolve(json.data);
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "getRSASignatureForMethod", "error", errorPayload);
            return Promise.reject(errorPayload);
        });
};

//PayAsYouGo application subscription
export const subscribeAnApplication = (userId, applicationId) => {
    LogService.trace(LOG_TAG, "subscribeAnApplication");

    return PaymentsService.subscribeAnApplication(userId, applicationId)
        .then(subscription => {
            LogService.debug(LOG_TAG, "subscribeAnApplication success", subscription.status);
            return waitForSubscriptionStatusActive(userId, subscription._id);
            // return new Promise(resolve => setTimeout(() => resolve(), 8000));
        })
        .catch(errorPayload => {
            return Promise.reject(errorPayload);
        });
};

const waitForSubscriptionStatusActive = (userId, subscriptionId, maxTrial = SubscriptionPollingWaitMaxTrial) => {
    LogService.debug(LOG_TAG, "waitForSubscriptionStatusActive");

    let handler = null;
    let count = 0;
    const pollingAction = (resolve, reject, maxCount) => {
        PaymentsService.getSubscriptionById(userId, subscriptionId)
            .then(subscription => {
                LogService.debug(LOG_TAG, "waitForSubscriptionStatusActive pollingAction getSubscriptionById", subscription.status, count);
                if (subscription.status === "active") {
                    clearInterval(handler);
                    resolve(subscription);
                } else if (count > maxCount) {
                    return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(new Error("max trial reached while waiting for subscription active status")));
                }
                count++;
            })
            .catch(errorPayload => {
                LogService.error(LOG_TAG, "waitForSubscriptionStatusActive pollingAction error", errorPayload);
                clearInterval(handler);
                reject(errorPayload);
            });
    };

    return new Promise((resolve, reject) => {
        handler = setInterval(() => {
            pollingAction(resolve, reject, maxTrial);
        }, 1000);
    });
}